import { Stack, Text } from "@sembark-travel/ui-base"
import { useCallback } from "react"
import { TLeadChannel } from "./store"
import { useMergeEntities } from "../shared/mergeUtils"
import {
	DuplicateEntityField,
	MergeConfirmation,
	MergeEntities,
	SelectPrimaryField,
} from "../shared/merge"

function LeadChannelItem({ leadChannel }: { leadChannel: TLeadChannel }) {
	return (
		<Stack gap="1" fontWeight="normal">
			<Text fontWeight="semibold">{leadChannel.name}</Text>
		</Stack>
	)
}

export function MergeLeadChannels({
	onSuccess,
	onCancel,
}: {
	onSuccess: (primary: TLeadChannel) => void
	onCancel: () => void
}) {
	const getId = useCallback((c: TLeadChannel) => c.id, [])
	const renderItem = useCallback(
		(c: TLeadChannel) => <LeadChannelItem leadChannel={c} />,
		[]
	)
	const mergeHook = useMergeEntities<TLeadChannel>({
		mergeUrl: "/lead-channels/merge",
		getId,
		onSuccess,
	})

	return (
		<MergeEntities<TLeadChannel>
			title="Merge Duplicate Lead Channels"
			entityLabel="Lead Channel"
			resetKey={mergeHook.resetKey}
			renderDuplicates={() => (
				<DuplicateEntityField<TLeadChannel>
					title="Duplicate Lead Channels"
					description="Please select the duplicate lead channels."
					url="/lead-channels"
					params={{ is_auto: 0 }}
					getId={getId}
					renderItem={renderItem}
				/>
			)}
			renderPrimary={() => (
				<SelectPrimaryField<TLeadChannel>
					entityLabel="Lead Channel"
					getId={getId}
					renderItem={renderItem}
				/>
			)}
			renderConfirmation={() => (
				<MergeConfirmation<TLeadChannel>
					entityLabel="Lead Channel"
					getId={getId}
					renderItem={renderItem}
					consequences={[
						"Replace all existing usage of the selected duplicate lead channels with primary Lead Channel",
						"Permanently delete the duplicate lead channels",
					]}
				/>
			)}
			onSubmit={(values, confirm) =>
				mergeHook.merge(
					values.primary,
					values.duplicates,
					confirm,
					"Lead Channel"
				)
			}
			onCancel={onCancel}
		/>
	)
}
